import React from 'react'
import { Button } from 'transfix-ui/components/Button'
import { getUserCookieValues } from 'utils/userAuth'

const LocalLogin = () => {
  const clickHandler = async () => {
    const cookieValues = await getUserCookieValues()

    window.open(
      `http://localhost:8090?localLogin=${encodeURIComponent(JSON.stringify(cookieValues))}`
    )
  }

  return <Button onClick={clickHandler}>Login Local Rogers</Button>
}

export default LocalLogin
